module.exports = __webpack_public_path__ + "static/ffuncars-free-pickup-f2a38fa73d0fb20be6c5b9762cd0f7d0.webp";